// Lightweight analytics: tracks user engagement events to Supabase
// All inserts are fire-and-forget, never block the UI

import { supabase } from '../supabase';

const COLLECTION = process.env.REACT_APP_COLLECTION || null;

// Per-tab session ID (random, lasts for the tab's lifetime)
const SESSION_KEY = 'maqom_session_id';
let sessionId = sessionStorage.getItem(SESSION_KEY);
if (!sessionId) {
  sessionId = Math.random().toString(36).slice(2) + Date.now().toString(36);
  sessionStorage.setItem(SESSION_KEY, sessionId);
}

let cachedUserId = null;

// Update user ID when auth state changes
supabase.auth.onAuthStateChange((_event, session) => {
  cachedUserId = session?.user?.id || null;
});
// Initial fetch
supabase.auth.getSession().then(({ data }) => {
  cachedUserId = data.session?.user?.id || null;
});

/**
 * Track an event. Fire-and-forget; failures are silent.
 *
 * @param {string} eventType  e.g. 'page_view', 'search', 'modal_open', 'geotag_confirmed'
 * @param {object} extra      optional: { item_id, metadata: { ... } }
 */
export function trackEvent(eventType, extra = {}) {
  try {
    const payload = {
      collection: COLLECTION,
      session_id: sessionId,
      event_type: eventType,
      user_id: cachedUserId,
      item_id: extra.item_id ?? null,
      metadata: extra.metadata ?? null,
    };
    // Fire and forget — don't await, don't block
    supabase.from('events').insert(payload).then(() => {}, () => {});
  } catch (e) {
    // Silently ignore
  }
}
